import { UserService } from 'src/app/services/user/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { EnterpriseSettingService } from 'src/app/services/enterprise-setting/enterprise-setting.service';
import { EnterpriseNotificationUserModalComponent } from 'src/app/shared/components/modals/enterprise/enterprise-notification-user-modal/enterprise-notification-user-modal.component';
import { MessageModalComponent } from 'src/app/shared/components/modals/message/message-modal.component';
import { RoleModalComponent } from 'src/app/shared/components/modals/role/role-modal.component';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import {
  AlertService,
  MessageSeverity,
} from 'src/app/shared/services/alert.service';
import { EmitterService } from 'src/app/shared/services/emitter.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { decryptData } from 'src/app/shared/helpers/decrypt';

@Component({
  selector: 'app-enterprise-profile',
  templateUrl: './enterprise-profile.component.html',
  styleUrls: ['./enterprise-profile.component.css'],
})
export class EnterpriseProfileComponent implements OnInit {
  alerts: any[];
  isImageSizeCorrect = true;
  settingForm: FormGroup;
  title: string;
  loading: boolean = false;
  isAdminGys: boolean = false;
  sessionUserId: string;
  storageFileSelect: number;
  logo = '../../../../../../assets/images/enterprise-default.png';
  fileLogo: File;
  idEnterprise: number;
  color1: string;
  color2: string;
  colorFont: string;
  colorFont2: string;
  enabledRead: number;
  enabledWrite: number;
  enableAlertMin: boolean = false;
  enableAlertMax: boolean = false;
  colorPrimary: string;
  colorSecundary: string;
  photoPreview: string;
  enterpriseSelect: number = 0;
  headquarterSelect: number = 0;
  limitTimerCameraOff: number = 0;
  idUser: number;
  systems:any;

  constructor(
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private router: Router,
    private notificationService: NotificationService,
    private enterpriseSettingService: EnterpriseSettingService,
    private alertService: AlertService,
    private emitterService: EmitterService,
    private userService: UserService
  ) {
    this.idEnterprise = +localStorage.getItem(AppConstants.Session.ENTERPRISE);
    document.getElementById('titleHeaderNav').innerHTML ='<span class="font-weight-bold">Configuración</span>';
    var dd = decryptData(localStorage.getItem(AppConstants.Session.ENTERPRISE_SYSTEM));
    this.systems = JSON.parse(dd);
    if((this.systems.Iot == null || this.systems.Iot == undefined) && (this.systems.iot == null || this.systems.iot == undefined)){
      this.systems = JSON.parse(this.systems);
    }
  }

  setTheme() {
    this.idEnterprise = +localStorage.getItem(AppConstants.Session.ENTERPRISE);
    this.idUser = +localStorage.getItem(AppConstants.Session.USERID);
    this.color1 = localStorage.getItem(AppConstants.Session.THEME_COLOR1);
    this.color2 = localStorage.getItem(AppConstants.Session.THEME_COLOR2);
    this.colorFont = localStorage.getItem(
      AppConstants.Session.THEME_COLOR_FONT
    );
    this.colorFont2 = localStorage.getItem(
      AppConstants.Session.THEME_COLOR_FONT2
    );
    this.enterpriseSelect = +localStorage.getItem(
      AppConstants.Session.ENTERPRISE
    );
    this.headquarterSelect = +localStorage.getItem(
      AppConstants.Session.HEADQUARTER
    );
    //validate Permisses menu
    var menu = JSON.parse(localStorage.getItem(AppConstants.Session.MENU));
    var page = this.router.url.split('/');
    var i = page[page.length - 1];
    var itemTag = menu.filter(
      (x) => x.tag != null && x.tag.toString().toLowerCase().includes(i)
    );
    if (itemTag.length > 0) {
      this.enabledRead = itemTag[0].activeRead;
      this.enabledWrite = itemTag[0].activeWrite;
    } else {
      this.enabledRead = 0;
      this.enabledWrite = 0;
    }
  }

  ngOnInit() {
    this.setTheme();
    this.title = AppConstants.TitleModal.UPDATE_ENTERPRISE_SETTING;
    this.isAdminGys =
      +localStorage.getItem(AppConstants.Session.ROLID) ==
        AppConstants.UserRole.AdministradorGyS ||
      +localStorage.getItem(AppConstants.Session.ROLID) ==
        AppConstants.UserRole.UsuarioGyS
        ? true
        : false;
    this.sessionUserId = localStorage.getItem(AppConstants.Session.USERID);
    this.createForm();
    this.getData();
    this.getAlertSetting();
  }

  getData() {
    this.spinner.show();
    this.enterpriseSettingService
      .getEnterpriseSetting(this.idEnterprise)
      .subscribe(
        (response) => {
          if (response.error == null && response.enterpriseSetting != null) {
            this.settingForm.patchValue({
              idEnterprise: this.idEnterprise,
              color1: '', //response.enterpriseSetting.color1,
              color2: '',
              /*idStorageFile: response.enterpriseSetting.idStorageFile,
          pathFile: response.enterpriseSetting.pathFile,*/
              userId: parseInt(this.sessionUserId),
            });
            this.colorPrimary = response.enterpriseSetting.color1;
            this.colorSecundary = response.enterpriseSetting.color2;
            this.limitTimerCameraOff = response.enterpriseSetting.limitTimerCameraOff;
            this.enableAlertMax = response.enterpriseSetting.enableAlertMax
              ? true
              : false;
            this.enableAlertMin = response.enterpriseSetting.enableAlertMin
              ? true
              : false;
            if (
              response.enterpriseSetting.logo != '' &&
              response.enterpriseSetting.logo
            ) {
              if (response.enterpriseSetting.idStorageType == 2) {
                //azure
                this.logo = response.enterpriseSetting.logo;
              } else {
                this.logo =
                  response.enterpriseSetting.storagePath +
                  '/' +
                  response.enterpriseSetting.logo;
              }
            }
          }
          this.spinner.hide();
        },
        (error: HttpErrorResponse) => {
          this.spinner.hide();
        }
      );
  }

  createForm() {
    this.settingForm = this.formBuilder.group({
      idEnterprise: this.idEnterprise,
      color1: [true, []],
      color2: [true, []],
      userId: parseInt(this.sessionUserId),
      limitTimerCameraOff:[0, []]
    });
  }

  get f() {
    return this.settingForm.controls;
  }

  openConfirmationModal() {
    if (this.settingForm.valid) {
      let dialogRef = this.dialog.open(MessageModalComponent, {
        data: {
          title: AppConstants.TitleModal.ENTERPRISE_SETTING_UPDATE,
          message:
            AppConstants.MessageModal.UPDATE_MESSAGE_ENTERPRISE_SETTING_CONFIRM,
          hasButton: true,
          contentButton: {
            yes: 'SI',
            no: 'CANCELAR',
          },
        },
      });

      dialogRef.afterClosed().subscribe((response) => {
        if (response.result == true) {
          this.update();
        }
      });
    } else {
      this.settingForm.markAllAsTouched();
    }
  }

  update() {
    if (this.settingForm.valid) {
      this.spinner.show();

      var formData = new FormData();
      formData.append('color1', this.colorPrimary);
      formData.append('color2', this.colorSecundary);
      formData.append('userId', this.sessionUserId);
      formData.append('enableAlertMin', this.enableAlertMin ? '1' : '0');
      formData.append('enableAlertMax', this.enableAlertMax ? '1' : '0');
      formData.append('idEnterprise', this.idEnterprise.toString());
      formData.append('limitTimerCameraOff', this.limitTimerCameraOff.toString());
      formData.append('logo', this.fileLogo);

      this.enterpriseSettingService.updateEnterpriseSetting(formData).subscribe(
        (response) => {
          this.alertService.showMessage(
            '',
            AppConstants.MessageModal.UPDATE_ENTERPRISE_SETTING,
            MessageSeverity.success
          );
          this.spinner.hide();
          localStorage.setItem(
            AppConstants.Session.THEME_COLOR1,
            this.colorPrimary
          );
          localStorage.setItem(
            AppConstants.Session.THEME_COLOR2,
            this.colorSecundary
          );
          if (this.fileLogo) {
            localStorage.setItem(
              AppConstants.Session.LOGO,
              this.photoPreview.toString()
            );
          }
          window.location.reload();
        },
        (error: HttpErrorResponse) => {
          this.alertService.showMessage(
            '',
            error.error.messages,
            MessageSeverity.error
          );
          this.spinner.hide();
        }
      );
    } else {
      this.settingForm.markAllAsTouched();
      this.alertService.showMessage(
        '',
        AppConstants.MessageModal,
        MessageSeverity.error
      );
    }
  }

  checkAlertMin(event: MatSlideToggleChange) {
    this.enableAlertMin = event.checked;
  }

  checkAlertMax(event: MatSlideToggleChange) {
    this.enableAlertMax = event.checked;
  }

  close() {
    this.dialog.closeAll();
  }

  //GUARDAMOS LA FOTO Y VERIFICAMOS SI CUMPLE CON EL 80X80
  onFileSelected(event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      var _this = this;
      reader.onload = (event: any) => {
        const tempLogo = event.target.result;

        // Crear una nueva imagen para verificar sus dimensiones
        const img = new Image();
        img.src = tempLogo;
        img.onload = () => {
          const width = img.naturalWidth;
          const height = img.naturalHeight;

          if (width !== 80 || height !== 80) {
            this.isImageSizeCorrect = false;
            this.alertService.showMessage(
              'Error al cargar la imagen',
              AppConstants.MessageModal.LOGO_SIZE,
              MessageSeverity.error
            );
          } else {
            this.isImageSizeCorrect = true;
            _this.logo = tempLogo; // Asignar la imagen a this.logo solo si cumple con las dimensiones requeridas
            this.photoPreview = reader.result as string
          }
        };
      };
      // Continuar con la subida de la foto
      reader.readAsDataURL(event.target.files[0]);
      this.fileLogo = event.target.files[0];
    }
  }

  //OBTENEMOS LAS ALERTAS DE LA EMPRESA
  getAlertSetting() {
    this.alerts = [];
    this.notificationService
      .getEnterpriseAlertSetting(this.idEnterprise)
      .subscribe(
        (response) => {
          if (response.error == null) {
            this.alerts = response.data;
          }
        },
        (error: HttpErrorResponse) => {
          this.loading = false;
        }
      );
  }

  //ABRIMOS EL ALERTCOMPONENT PARA AGREGAR NUEVO CORREO
  openDialog(alert) {
    var dialogRef = this.dialog.open(EnterpriseNotificationUserModalComponent, {
      data: {
        title: AppConstants.TitleModal.ADD_NEW_EMAIL_FOR_ALERT,
        action: AppConstants.OperationType.ADD,
        idEnterprise: this.enterpriseSelect,
        idHeadquarter: this.headquarterSelect,
        isAdminGys: this.isAdminGys,
        color: this.color1,
        colorFont: this.color2,
        enabledWrite: this.enabledWrite,
        enabledRead: this.enabledRead,
        alert: alert,
      },
       width: '350px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if(result.add){
        alert.emails = result.emails;
      }
    });
  }

  //ELIMINAMOS UN CORREO
  removeEmail(alert, email, i) {
    const dialogRef = this.dialog.open(MessageModalComponent, {
      width: '250px',
      data: {
        title: AppConstants.TitleModal.DELETE_EMAIL_FOR_ALERT,
        message:
          AppConstants.MessageModal.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_EMAIL,
        hasButton: true,
        contentButton: {
          yes: 'SI',
          no: 'CANCELAR',
        },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // El usuario confirmó la eliminación

        // Dividir la cadena de correos electrónicos en un array
        let emailsArray = alert.emails.split(',');

        // Eliminar el correo electrónico deseado del array
        const index = emailsArray.indexOf(email);
        if (index > -1) {
          emailsArray.splice(index, 1);
        }

        // Unir el array de nuevo en una cadena
        alert.emails = emailsArray.join(',');

        var payload = {
          idUser: this.idUser,
          idEnterprise: this.idEnterprise,
          emails: alert.emails,
          idAlertType: alert.idAlertType,
          email: email,
          insert: 0,
        };

        this.notificationService
          .updateEnterpriseSettingEmail(payload)
          .subscribe(
            (response) => {
              console.log(response);
            },
            (error) => {
              console.error(error);
            }
          );
      }
    });
  }
}
